import React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select, {SelectChangeEvent} from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import {DatabaseMetadataEstado} from '../../utils/enums';
import {DatabaseMetadataEstadoUtils} from '../../utils/DatabaseMetadadaEstadoUtils';
import {DatabaseMetadataSelectEstadoProps} from './DatabaseMetadataTableComponentsProps';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
   PaperProps: {
      style: {
         maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
         width: 250
      }
   }
};

const estados = [
   DatabaseMetadataEstado.OK,
   DatabaseMetadataEstado.EXPIRADA,
   DatabaseMetadataEstado.FANTASMA,
   DatabaseMetadataEstado.HUERFANA,
   DatabaseMetadataEstado.DESCONOCIDA
];

const DatabaseMetadataEstadoSelect: React.FC<DatabaseMetadataSelectEstadoProps> = ({
   estadosElegidos,
   onEstadosElegidosChange
}) => {
   const handleChange = (event: SelectChangeEvent<typeof estadosElegidos>) => {
      const {
         target: {value}
      } = event;
      const newEstadosElegidos = typeof value === 'string' ? value.split(',') : value;
      onEstadosElegidosChange(newEstadosElegidos);
   };

   return (
      <div>
         <FormControl sx={{m: 1, width: 150}} size="small" fullWidth>
            <InputLabel id="demo-multiple-checkbox-label">Estados</InputLabel>
            <Select
               labelId="demo-multiple-checkbox-label"
               id="demo-multiple-checkbox"
               multiple
               value={estadosElegidos}
               onChange={handleChange}
               input={<OutlinedInput label="Estados" />}
               renderValue={selected => selected.join(', ')}
               MenuProps={MenuProps}
               size="small"
               fullWidth
            >
               {estados.map(name => {
                  return (
                     <MenuItem
                        sx={{backgroundColor: DatabaseMetadataEstadoUtils.getColor(name).light,
                           '&:hover': {backgroundColor: DatabaseMetadataEstadoUtils.getColor(name).main}}}
                        key={name}
                        value={name}
                     >
                        <Checkbox checked={estadosElegidos.indexOf(name) > -1} />
                        <ListItemText primary={name} />
                     </MenuItem>
                  );
               })}
            </Select>
         </FormControl>
      </div>
   );
};

export default DatabaseMetadataEstadoSelect;
